import React from 'react';
import { Route } from 'react-router-dom';

import {NoMatch} from "../../components";

export default ({ session: session, component: Component, ...rest }) => {
  
    if(session.isFetching) return null;

    return (
      session.isLoggedIn ?
      <Route {...rest} render={props => (<Component {...props}/>)}/>
      : <Route component={NoMatch}/>
      )
}


// WEBPACK FOOTER //
// ./src/components/Commons/PrivateRoute.js